import { PLAN_TYPE, DateFormat } from '@logz-pkg/enums';
import moment from 'moment';
import { cloneDeep, isNil } from 'lodash';
export class PlanDetailsModelManipulator {
    isTrial = (planDetails) => planDetails?.planType === PLAN_TYPE.TRIAL;
    isFree = (planDetails) => planDetails?.planType === PLAN_TYPE.FREE;
    isEnterprise = (planDetails) => planDetails?.planType === PLAN_TYPE.ENTERPRISE;
    isPro = (planDetails) => planDetails?.planType === PLAN_TYPE.PRO;
    trialDaysLeft = ({ planType, endDate }) => this.isTrial({ planType }) ? -1 * moment({ hours: 0 }).diff(endDate.valueOf(), 'days') : null;
    mergePlanCapacity = (planCapacity, planDetails) => {
        const planDetailsClone = cloneDeep(planDetails);
        planDetailsClone.maxDailyGb = planCapacity.volumeGB;
        planDetailsClone.retentionDays = planCapacity.retentionDays;
        return planDetailsClone;
    };
    mergePlanType = (planType, planDetails) => {
        const planDetailsClone = cloneDeep(planDetails);
        planDetailsClone.planType = planType;
        return planDetailsClone;
    };
    getFormattedStartDate = (planDetails) => planDetails.startDate.format(DateFormat.Date).toString();
    getMaxDailyGb = (planDetails) => planDetails.isFlexible && planDetails.totalTimeBasedDailyGb
        ? planDetails.totalTimeBasedDailyGb
        : planDetails.maxDailyGb;
    getPlanVolumeGb = (planDetails) => {
        if (planDetails.isFlexible && isNil(planDetails.totalTimeBasedDailyGb)) {
            // Flexible sub-accounts
            return planDetails.reservedDailyGb || 0;
        }
        return this.getMaxDailyGb(planDetails);
    };
}
export const planDetailsModelManipulator = new PlanDetailsModelManipulator();
//# sourceMappingURL=plan-details.manipulator.js.map